import axios from 'axios';
import { BUSINESS_ADMIN_HOST } from 'api/constants';

const ADDON_PRODUCTS_URL = `${BUSINESS_ADMIN_HOST}/v1/products`;

export function getAddonProductsApi() {
  return axios.get(ADDON_PRODUCTS_URL, {
    params: { type: 'ADD_ON' },
  });
}

export function updateAddonProductPriceApi(productId, priceData) {
  return axios.put(`${ADDON_PRODUCTS_URL}/${productId}`, priceData);
}

export function getAdditionalServiceLogs(page, size) {
  return axios.get(`${BUSINESS_ADMIN_HOST}/v1/logs?group=products_add_on`, {
    params: { page, size },
  });
}
